// Direction is a byte in 0..255 with 0 = North (up), increasing clockwise
// (Brain.h convention). World coordinates use top-left origin with y
// increasing downward.

const TWO_PI = Math.PI * 2;

// Convert direction byte to a unit (dx, dy) using the exact angle.
// Used for shells and other entities that benefit from continuous angles
// (pillbox aim is computed precisely; shells should fly along that exact
// vector, not snapped). Tank movement explicitly snaps via snapDir() first.
export function dirVector(dir: number): { dx: number; dy: number } {
  const wrapped = ((dir % 256) + 256) % 256;
  const a = (wrapped / 256) * TWO_PI;
  return { dx: Math.sin(a), dy: -Math.cos(a) };
}

// Returns the same fractional `dir` snapped to one of 16 discrete steps —
// matches the WinBolo tank sprite sheet's 16 facings. Tanks call this on
// their `dir` before passing to dirVector so motion stays aligned with
// the rendered sprite (otherwise fractional dir produces a "strafe" effect
// where the tank visibly moves off the angle the sprite is showing).
export function snapDir(dir: number): number {
  const wrapped = ((dir % 256) + 256) % 256;
  return (Math.round(wrapped / 16) * 16) % 256;
}

export function tileX(worldX: number): number {
  return (worldX >> 8) & 0xff;
}

export function tileY(worldY: number): number {
  return (worldY >> 8) & 0xff;
}

// Convert a BMAP start-direction (0..15, 0=East CCW, 22.5° steps) to the
// runtime direction byte (0..255, 0=N clockwise).
export function bmapDirToRuntime(bmapDir: number): number {
  // BMAP: 0=E, 4=N, 8=W, 12=S (counterclockwise math convention)
  // Runtime: 0=N, 64=E, 128=S, 192=W (clockwise compass convention)
  // Mapping: runtime = (64 - bmapDir * 16) mod 256
  const r = (64 - (bmapDir & 0x0f) * 16) & 0xff;
  return r;
}
